import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar2 from "../components/navbar/Navbar2";
import crazyImg from "../assets/crazy1.webp";
import latlatImg from "../assets/LatLat11.jpg";
import BingoImg from "../assets/bingo1.avif";
import Featured1 from "../assets/horse-game.webp";
import Featured2 from "../assets/Mega-bloks.jfif";
import Featured3 from "../assets/feature1.avif";
import kenoImg from "../assets/kenologo.jpg";
import { useNavigate } from "react-router-dom";

const games = [
  { name: "Bingo Games", link: "betamountpage", image: BingoImg },
  { name: "Fast Keno", link: "keno-game", image: kenoImg },
  { name: "Crazy Carta", link: "crazy-games", image: crazyImg },
  { name: "LatLat Carta", link: "latlat-games", image: latlatImg },
];
const featured_games = [
  { name: "Coming Soon", link: "", image: Featured1 },
  { name: "Coming Soon", link: "", image: Featured2 },
  { name: "Coming Soon", link: "", image: Featured3 },
];

export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <>
      {/* Floating Animation Icons */}
      <div className="particle-container">
        {[...Array(60)].map((_, i) => {
          const type = i % 4; // 4 motion types

          return (
            <div
              key={i}
              className={`particle type-${type}`}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 8}s`,
                animationDuration: `${8 + Math.random() * 6}s`,
              }}
            />
          );
        })}
      </div>

      {/* Navbar */}
      <div className="fixed left-0 right-0 top-0 z-50">
        <Navbar2 />
      </div>

      <div className="min-h-screen bg-[#0b3557] flex flex-col items-center px-3 py-10 pt-28">
        <div className=" max-w-4xl mx-auto w-full">
          {/* Game Grid */}

          <div className="mb-4">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">
                Enat Games
              </h2>
            </div>
            <p className="text-gray-400 text-sm mb-2">
              Try the most popular games and win big.
            </p>

            <div className="grid grid-cols-3 gap-2">
              {games.map((game) => (
                <div
                  key={game.name}
                  onClick={() => navigate(`/${game.link.toLowerCase()}`)}
                  className="relative group cursor-pointer rounded-xl overflow-hidden border border-cyan-400 bg-[#0f3b63] shadow-[0_0_8px_rgba(34,211,238,0.4)]"
                >
                  {/* Image Section */}
                  <div className="relative">
                    <img
                      src={game.image}
                      alt={game.name}
                      className="w-full h-36 object-cover transition duration-300 group-hover:scale-110"
                    />

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/80 flex items-center justify-center shadow-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-gray-800 ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Title Panel */}
                  <div className="bg-gradient-to-r from-cyan-700 via-cyan-600 to-cyan-700 text-center py-2">
                    <p className="text-white font-semibold text-sm tracking-wide">
                      {game.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mb-1">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">
                Featured Games
              </h2>
            </div>
            <p className="text-gray-400 text-sm mb-2">
              Find the best games picked just for you.
            </p>

            <div className="grid grid-cols-3 gap-2">
              {featured_games.map((game) => (
                <div
                  key={game.name}
                  onClick={() => navigate(`/${game.link.toLowerCase()}`)}
                  className="relative group cursor-pointer rounded-xl overflow-hidden border border-cyan-400 bg-[#0f3b63] shadow-[0_0_8px_rgba(34,211,238,0.4)]"
                >
                  {/* Image Section */}
                  <div className="relative">
                    <img
                      src={game.image}
                      alt={game.name}
                      className="w-full h-36 object-cover transition duration-300 group-hover:scale-110"
                    />

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/80 flex items-center justify-center shadow-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-gray-800 ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Title Panel */}
                  <div className="bg-gradient-to-r from-cyan-700 via-cyan-600 to-cyan-700 text-center py-2">
                    <p className="text-white font-semibold text-sm tracking-wide">
                      {game.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* ✅ More Games Section */}
          <div className="mt-6 w-full">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">
                Quick Links
              </h2>
            </div>

            {/* Provider Buttons */}
            <div className="flex gap-3 overflow-x-auto no-scrollbar pb-2">
              {[
                { name: "Wallet", link: "wallet", count: 1 },
                { name: "Bingo Games", link: "betamountpage", count: 96 },
                { name: "LatLat", link: "latlat-games", count: 2 },
                { name: "Crazy", link: "crazy-games", count: 4 },
              ].map((provider, i) => (
                <button
                  key={i}
                  onClick={() => navigate(`/${provider.link.toLowerCase()}`)}
                  className={`
          flex items-center gap-2
          px-5 py-2
          rounded-full
          whitespace-nowrap
          text-sm font-medium
          transition-all duration-300
          bg-cyan-900/40
          text-gray-200
          border border-cyan-700/40
          hover:bg-cyan-600
        `}
                >
                  {provider.name}
                  <span className="bg-cyan-700 text-xs px-2 py-0.5 rounded-full">
                    {provider.count}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="mt-16 text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Play Enat Games
          </div>
        </div>
      </div>

      {/* Animation Styles */}
      <style jsx>{`
        .particle-container {
          position: fixed;
          inset: 0;
          pointer-events: none;
          overflow: hidden;
          z-index: 0;
        }

        .particle {
          position: absolute;
          width: 6px;
          height: 6px;
          background: rgba(0, 255, 255, 0.6);
          border-radius: 50%;
          filter: blur(1px);
        }

        /* 1️⃣ Top → Bottom */
        .type-0 {
          animation: fallDown linear infinite;
        }

        @keyframes fallDown {
          0% {
            transform: translateY(-10vh);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translateY(110vh);
            opacity: 0;
          }
        }

        /* 2️⃣ Left → Right */
        .type-1 {
          animation: moveRight linear infinite;
        }

        @keyframes moveRight {
          0% {
            transform: translateX(-10vw);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translateX(110vw);
            opacity: 0;
          }
        }

        /* 3️⃣ Top-Left → Bottom-Right */
        .type-2 {
          animation: diagonal1 linear infinite;
        }

        @keyframes diagonal1 {
          0% {
            transform: translate(-10vw, -10vh);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translate(110vw, 110vh);
            opacity: 0;
          }
        }

        /* 4️⃣ Top-Right → Bottom-Left */
        .type-3 {
          animation: diagonal2 linear infinite;
        }

        @keyframes diagonal2 {
          0% {
            transform: translate(10vw, -10vh);
            opacity: 0;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform: translate(-110vw, 110vh);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
}
